import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  width: 100%;
  gap: 20px;
  padding: 10px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;
